// map of variant id to restock date, serialized in the section liquid
const restockDates = JSON.parse(document.querySelector("#productV14RestockJSON").textContent);

/************
 Swipers
 ************/

// thumbnails mobile
let productV14ThumbnailImages = new Swiper("#productV14ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV14ThumbnailsNext',
        prevEl: '#productV14ThumbnailsPrev',
    },
});

// play video in the currently active slide (videos are muted + loop, so we never pause)
function playActiveSlideVideoV14(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide?.querySelector("video");
    if (!video) {
        return;
    }
    video.play();
}

// main swiper
let productV14Images = new Swiper("#productV14Swiper", {
    navigation: {
        nextEl: '#productV14Swiper .productV14SwiperNext',
        prevEl: '#productV14Swiper .productV14SwiperPrev',
    },
    autoHeight: true,
    loop: true,
    thumbs: {
        swiper: productV14ThumbnailImages
    },
    on: {
        init: function () {
            playActiveSlideVideoV14(this);
        },
        slideChange: function () {
            playActiveSlideVideoV14(this);
        }
    }
});

// gallery desktop
document.querySelectorAll(".productV14GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV14Images.slideTo(index);
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll('.productV14Video')?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();

        // check if we're on mobile and if .videoPopupVideo.mobileOnly exists
        if (window.innerWidth < 800 && popup.querySelector(".videoPopupVideo.mobileOnly")) {
            popup.querySelector(".videoPopupVideo.mobileOnly").play();
        } else {
            popup.querySelector("video").play();
        }
    })
})


/*****************
 Reviews
 ****************/

document.querySelector("#productV14Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// update active variant
function updateProductV14() {


    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productV14FormGroup`).forEach(group => {
        options.push(group.querySelector(`input:checked`).value);
    });

    // find new variant based on the options
    activeVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // find variant image by matching filename (media.id and featured_image.id differ in shopify's media model)
    if (activeVariant.featured_image) {
        const variantFilename = activeVariant.featured_image.src.split("/").pop().split("?")[0];
        const variantImage = Array.from(document.querySelectorAll(".productV14SwiperSlide")).find(slide => {
            const img = slide.querySelector("img");
            return img && img.src.split("/").pop().split("?")[0] === variantFilename;
        });
        if (variantImage) {
            productV14Images.slideTo(getElIndex(variantImage));
        }
    }

    // in the variant available?
    let isAvailable = activeVariant.available;

    // default quantity and discount
    let quantity = 1;
    let discount = 0;

    // compute price and compare at price
    let total = activeVariant.price * quantity - discount;
    let compareAtTotal = activeVariant.compare_at_price * quantity;

    // check for addon
    const hasAddon = document.querySelector("#productV14AddonCheckboxInput:checked")
    if (hasAddon) {
        total += parseInt(document.querySelector(".productV14AddonFormVariantsItem:checked").dataset.price);
        compareAtTotal += parseInt(document.querySelector(".productV14AddonFormVariantsItem:checked").dataset.compare);
    }

    // calculate savings
    let savings = compareAtTotal - total;
    let savingsPercent = Math.round((savings / compareAtTotal) * 100);

    // update display
    if (total < compareAtTotal) {
        const prefix = hasAddon ? "BUNDLE" : "";
        document.querySelector("#productV14PriceCompare").textContent = price(compareAtTotal, true);
        document.querySelector("#productV14PriceActual").textContent = `${prefix} ${price(total, true)}`;
        document.querySelector("#productV14PriceSavings").textContent = `SAVE ${savingsPercent}%`;
        document.querySelector("#productV14PriceSavings").classList.add('active');

    } else {
        document.querySelector("#productV14PriceCompare").textContent = "";
        document.querySelector("#productV14PriceActual").textContent = price(total, true);
        document.querySelector("#productV14PriceSavings").classList.remove('active');
    }


    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV14ATC").classList.remove("oos");
        document.querySelector("#productV14ATC").textContent = document.querySelector("#productV14ATC").dataset.text;
    } else {
        document.querySelector("#productV14ATC").classList.add("oos");
        document.querySelector("#productV14ATC").textContent = "Sold Out — Notify Me When Available";
    }

    // update BOGO box prices
    let BOGOExists = document.querySelector('.productV14BOGO') || false;
    if (BOGOExists) {
        document.querySelector('.productV14BOGOPriceReal').textContent = price(activeVariant.price, true);
        document.querySelector('.productV14BOGOPriceCompare').textContent = "";
        if (activeVariant.compare_at_price > activeVariant.price) {
            document.querySelector('.productV14BOGOPriceCompare').textContent = price(activeVariant.compare_at_price, true);
        }
    }

    // swap the ship date to the new variant's restock date
    updateShipping();
}

// updateProductV14()

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV14FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.parentElement.querySelector(".productV14FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV14();
    });
});

// variant dropdown support on change
document.querySelector("#productV14FormVariants")?.addEventListener("change", updateProductV14);


// if url has bundle, preselect it
if (urlParams.has("bundle")) {
    document.querySelector(`.productV14BundleOptionsItemInput[value="${urlParams.get("bundle")}"]`)?.parentElement.click();
}

/****************
 *  Quantity
 *************/

let quantity = 1;

// minus
document.querySelector("#productV14QuantityMinus")?.addEventListener("click", function () {
    // must not be less than 1
    if (quantity === 1) {
        return;
    }

    // decrement by 1
    quantity--;
    document.querySelector("#productV14QuantityValue").textContent = quantity;
});

// plus
document.querySelector("#productV14QuantityPlus")?.addEventListener("click", function () {
    // increment by 1
    quantity++;
    document.querySelector("#productV14QuantityValue").textContent = quantity;
});


/***************
 Product Addon
 ****************/

// select addon
if (document.querySelector("#productV14Addon")) {
    // input change
    document.querySelector("#productV14AddonCheckboxInput").addEventListener("change", function () {
        // update product form
        updateProductV14();

        // on check
        if (this.checked) {
            // update active class on parent
            document.querySelector("#productV14Addon").classList.add("active");

            // uncheck bogo button
            document.querySelector('.productV14BOGO')?.classList.remove('active');

            quantity = 1;

            // hide note
            document.querySelector('#productV14Note')?.classList.remove('active');

            // switch slides
            productV14Images.slideTo(productV14Images.slides.length - 1);
        } else {
            // remove active class on parent
            document.querySelector("#productV14Addon").classList.remove("active");

            // check bogo button
            document.querySelector('.productV14BOGO')?.classList.add('active');
            productV14Images.slideTo(0);

            quantity = 2;

            // show note
            document.querySelector('#productV14Note')?.classList.add('active');

        }
    });

    // variant selection change
    document.querySelectorAll(".productV14AddonFormVariantsItem").forEach(function (element) {
        element.addEventListener("change", updateProductV14);
    });

}

/**************
 ORDERS REMAINING
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}


/**************
 Product ATC
 ***************/

// add to cart button
/*Code for adding Shipping Insurance*/
document.querySelector("#productV14ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // create form data
    let formData = {
        items: []
    };

    // normal product
    const lineItem = {
        quantity: quantity,
        id: activeVariant.id,
    };

    // oversold variants with an upcoming restock carry the ship date through to the cart and checkout
    const restockDateObj = getRestockDate();
    if (restockDateObj) {
        lineItem.properties = {
            Ships: formatShipsDate(restockDateObj)
        };
    }
    formData.items.push(lineItem);

    // check if we should go directly to checkout
    if (this.classList.contains('checkout')) {

        await clearCart();

        // add gift free gift
        formData.items.push(
            {
                quantity: 1,
                id: 47175294222586
            }
        )
        await addProduct(formData)

        window.location.href = '/checkout';

        // klaviyo tracking
        try {
            _learnq.push(['track', 'Added to Cart', item]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }

        // remove loading animation
        this.classList.remove("loading");

        return;
    }


    // add productV14
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }


    // open cart
    await openCart();


    // remove loading animation
    this.classList.remove("loading");

});

//new code for insurance below:
/*document.querySelector("#productV14ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // Check for out-of-stock
    if (this.classList.contains("oos")) {
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });
        if (!email) return;

        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        await fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        });
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });
        return;
    }

    // Add loading animation
    this.classList.add("loading");

    // Check cart item count
    let cart = await fetch('/cart.js').then(res => res.json());
    let isCartEmpty = cart.item_count === 0;

    // Create form data
    let formData = { items: [] };
    let quantity = document.querySelector('.productV14BOGO')?.classList.contains('active') ? 2 : 1;

    // Add main product
    formData.items.push({
        quantity: quantity,
        id: activeVariant.id,
    });

    // Add shipping insurance product if cart is empty
    const insuranceVariantId = 47279097708794;
    if (isCartEmpty) {
        formData.items.push({
            quantity: 1,
            id: insuranceVariantId,
        });
    }

    // Check for addon
    const hasAddon = !!document.querySelector("#productV14AddonCheckboxInput:checked");
    if (hasAddon) {
        formData.items.push({
            quantity: 1,
            id: parseInt(document.querySelector(".productV14AddonFormVariantsItem:checked").value),
        });
    }

    // Add products to cart
    await addProduct(formData);

    // After adding, update cart drawer
    cart = await fetch('/cart.js').then(res => res.json());

    // Hide insurance product visually
    setTimeout(() => {
        document.querySelectorAll('.cart-item').forEach(item => {
            if (parseInt(item.dataset.variantId) === insuranceVariantId) {
                item.style.display = 'none';
            }
        });

        // Insert package protection notice if not already there
        if (!document.querySelector('.package-protection-notice')) {
            const checkoutButton = document.querySelector('.cart__checkout-button');
            if (checkoutButton) {
                const notice = document.createElement('div');
                notice.className = 'package-protection-notice';
                notice.style.marginBottom = '10px';
                notice.style.fontSize = '14px';
                notice.style.backgroundColor = '#f0f8ff';
                notice.style.color = '#0a0a0a';
                notice.style.padding = '8px 12px';
                notice.style.borderRadius = '6px';
                notice.style.textAlign = 'center';
                notice.innerHTML = '✔️ Package Protection added! You’ll see it at checkout.';
                checkoutButton.parentNode.insertBefore(notice, checkoutButton);
            }
        }
    }, 500); // Small delay to wait for cart drawer to render

    // Klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // Remove loading animation
    this.classList.remove("loading");

    // Open cart
    await openCart();
});*/


//space
// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV14ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV14AddonCheckboxInput").checked) {
            document.querySelector("#productV14AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV14ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

const stickyAtcObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            document.querySelector("#productV14ATC").classList.remove("sticky");
        } else {
            document.querySelector("#productV14ATC").classList.add("sticky");
        }
    });
}, {
    rootMargin: "-100px 0px 0px 0px"
})

stickyAtcObserver.observe(document.querySelector("#productV14Content"));

// event listeners for dropdown items
document.querySelectorAll(`.productV14DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

/**************
 Shipping Time
 ***************/

// the active variant's restock date, or null when it has none or it has already passed
function getRestockDate() {
    const restockDate = restockDates[activeVariant.id];
    if (!restockDate) {
        return null;
    }

    // build the restock date from its parts so "2026-07-01" is treated as a local date, not UTC (which shifts the day)
    const [year, month, day] = restockDate.split("-").map(Number);
    const restockDateObj = new Date(year, month - 1, day);
    if (new Date() >= restockDateObj) {
        return null;
    }

    return restockDateObj;
}

// format a date like "Oct 8th" for the Ships line item property
function formatShipsDate(date) {
    const day = date.getDate();

    // 11th, 12th and 13th break the st/nd/rd pattern
    let suffix = "th";
    if (day % 100 < 11 || day % 100 > 13) {
        suffix = {1: "st", 2: "nd", 3: "rd"}[day % 10] || "th";
    }

    return `${date.toLocaleDateString("en-US", {month: "short"})} ${day}${suffix}`;
}

// show the restock date as the ship date until it passes, otherwise ships tomorrow
function updateShipping() {
    const shippingDateTxt = document.querySelector("#productV14ShippingDateTxt");

    const restockDateObj = getRestockDate();
    if (restockDateObj) {
        const restockText = restockDateObj.toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"});
        shippingDateTxt.innerHTML = `Ships <strong>${restockText}</strong>`;
        return;
    }

    // no upcoming restock, so fall back to the default in-stock text
    shippingDateTxt.innerHTML = `In Stock - Ships <strong>Tomorrow</strong>`;
}

// initial paint for the default variant
updateShipping();
